import get from "lodash/get"

export const isLinesUsedInDates = () => {
  return get(window.Widget, 'flags.ticket_status_badge[0]') === 'line';
}